export default __webpack_public_path__ + "assets/roller-guy.ee509437.svg";